import { render, staticRenderFns } from "./VManualInvoice.vue?vue&type=template&id=1967faaa&"
import script from "./VManualInvoice.vue?vue&type=script&lang=js&"
export * from "./VManualInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports